import script from "./training-type-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./training-type-modal.vue?vue&type=script&setup=true&lang=js"

import "./training-type-modal.vue?vue&type=style&index=0&id=74430e09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74430e09"]])

export default __exports__